import React, { useState, useEffect } from 'react';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase'; 
import NavbarAdmin from '../components/NavbarAdmin';
import './styles/AddStatistics.css'; 

const AddStatDomaine = () => {
  // State with internal keys used for Firestore storage
  const [statistics, setStatistics] = useState({
    AgricultureMontant: 0,
    AgricultureNombre: 0,
    IndustrieMontant: 0,
    IndustrieNombre: 0,
    CommerceMontant: 0,
    CommerceNombre: 0,
    ServicesMontant: 0,
    ServicesNombre: 0,
    ArtisanatMontant: 0,
    ArtisanatNombre: 0,
    Amelioration_des_conditions_de_vieMontant: 0,
    Amelioration_des_conditions_de_vieNombre: 0,
    Cultures_maraicheresMontant: 0,
    Cultures_maraicheresNombre: 0,
    Grandes_culturesMontant: 0,
    Grandes_culturesNombre: 0,
    annee: ''
  });

  // User-friendly labels for display
  const labels = {
    Agriculture: 'Agriculture',
    Industrie: 'Industrie',
    Commerce: 'Commerce',
    Services: 'Services',
    Artisanat: 'Artisanat',
    Amelioration_des_conditions_de_vie: 'Amélioration des Conditions de Vie',
    Cultures_maraicheres: 'Cultures Maraîchères',
    Grandes_cultures: 'Grandes Cultures'
  };

  const [years, setYears] = useState([]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 5;
    const endYear = currentYear + 5;
    const yearsArray = [];
    for (let year = startYear; year <= endYear; year++) {
      yearsArray.push(year);
    }
    setYears(yearsArray);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const newValue = value === '' ? 0 : parseFloat(value);
    setStatistics((prevStats) => ({
      ...prevStats,
      [name]: isNaN(newValue) ? 0 : newValue
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("Submitting data: ", statistics); // Debugging line
      await addDoc(collection(db, 'statistics_domaine'), {
        ...statistics,
        timestamp: Timestamp.now()
      });
      console.log("Document successfully written!");
      setStatistics({
        AgricultureMontant: 0,
        AgricultureNombre: 0,
        IndustrieMontant: 0,
        IndustrieNombre: 0,
        CommerceMontant: 0,
        CommerceNombre: 0,
        ServicesMontant: 0,
        ServicesNombre: 0,
        ArtisanatMontant: 0,
        ArtisanatNombre: 0,
        Amelioration_des_conditions_de_vieMontant: 0,
        Amelioration_des_conditions_de_vieNombre: 0,
        Cultures_maraicheresMontant: 0,
        Cultures_maraicheresNombre: 0,
        Grandes_culturesMontant: 0,
        Grandes_culturesNombre: 0,
        annee: ''
      });
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  const headingStyle = {
    fontSize: '2rem',
    color: '#6699CC',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0',
    textAlign: 'center',
    borderBottom: '2px solid #ddd',
    paddingBottom: '10px',
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#6699CC',
    border: 'none',
    borderRadius: '4px',
    color: '#fff',
    fontSize: '1rem',
    cursor: 'pointer',
  };

  return (
    <div>
      <NavbarAdmin />
      <div className="add-statistics-container">
        <h2 style={headingStyle}>Ajouter les Statistiques par Secteur</h2>
        <form className="add-statistics-form" onSubmit={handleSubmit}>
          {Object.keys(labels).map((key, index) => (
            <div key={index} className='form-group'>
              <h3>{labels[key]}</h3>
              <div className='input-group'>
                <div className='input-item'>
                  <label>
                    Montant:
                    <input
                      type="number"
                      name={`${key}Montant`}
                      value={statistics[`${key}Montant`] || ''}
                      onChange={handleInputChange}
                      step="0.01"
                      required
                    />
                  </label>
                </div>
                <div className='input-item'>
                  <label>
                    Nombre de personnes:
                    <input
                      type="number"
                      name={`${key}Nombre`}
                      value={statistics[`${key}Nombre`] || ''}
                      onChange={handleInputChange}
                      step="1"
                      required
                    />
                  </label>
                </div>
              </div>
            </div>
          ))}
          <div className='form-group'>
            <h3>Année:</h3>
            <center>
              <select
                className='annee-select'
                name="annee"
                value={statistics.annee}
                onChange={handleInputChange}
                required
              >
                <option value="" disabled>Choisissez une année</option>
                {years.map((year) => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
            </center>
          </div>
          <button type="submit" style={buttonStyle}>Ajouter</button>
        </form>
      </div>
    </div>
  );
};

export default AddStatDomaine;
